import { Component, inject } from '@angular/core';
import { DxTabsComponent } from 'devextreme-angular';
import { AccessType, AuthService, PermissionType } from '@services';
import { EmptyTrailerScoreComponent } from './empty-trailer-score/empty-trailer-score.component';
import { ShuntProductivityScoreComponent } from './shunt-productivity-score/shunt-productivity-score.component';
import { YardCapacityScoreComponent } from './yard-capacity-score/yard-capacity-score.component';

type TabKey = 'yardCapacity' | 'emptyTrailerAging' | 'shuntProductivity';

@Component({
    selector: 'app-yard-score',
    imports: [
        DxTabsComponent,
        EmptyTrailerScoreComponent,
        ShuntProductivityScoreComponent,
        YardCapacityScoreComponent,
    ],
    templateUrl: './yard-score.component.html',
})
export class YardScoreComponent {
    private auth = inject(AuthService);

    get showYardCapacity(): boolean {
        return this.auth.checkPermission(PermissionType.YardCapacityScore, AccessType.Manage);
    }

    get showEmptyTrailerAging(): boolean {
        return this.auth.checkPermission(PermissionType.EmptyTrailerAgingScore, AccessType.ViewOnly);
    }

    get showShuntProductivity(): boolean {
        return this.auth.checkPermission(PermissionType.ShuntProductivityScore, AccessType.ViewOnly);
    }

    selectedTab: TabKey = this.showYardCapacity ? 'yardCapacity' : this.showEmptyTrailerAging ? 'emptyTrailerAging' : 'shuntProductivity';

    allTabs = [
        { key: 'yardCapacity', text: 'Yard Capacity', icon: '', permission: PermissionType.YardCapacityScore },
        { key: 'emptyTrailerAging', text: 'Empty Trailer Aging', icon: '', permission: PermissionType.EmptyTrailerAgingScore },
        { key: 'shuntProductivity', text: 'Shunt Productivity', icon: '', permission: PermissionType.ShuntProductivityScore },
    ];

    tabs = this.allTabs.filter((t) => this.auth.checkPermission(t.permission, AccessType.ViewOnly));
}
